const SmallBtn = ({
  title,
  onClick,
  style = {},
}: {
  title: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  style?: React.CSSProperties;
}) => {
  return (
    <button
      onClick={onClick}
      className="btn btn-success"
      style={{ fontFamily: "Acme", fontSize: 25, ...style }}
    >
      {title}
    </button>
  );
};

export default SmallBtn;
